<script>
import TheAchievementKindSelect from "./TheAchievementKindSelect.vue";
import CriteriaAchievementTextField from "./CriteriaAchievementTextField.vue";
import TheAchievementFileInput from "./TheAchievementFileInput.vue";
import {createHelpers} from "vuex-map-fields";
import {mapActions, mapGetters, mapState} from "vuex";
import _ from "lodash";
import Trophy from "../../Icons/Trophy.vue";
import store from "../../../../../stores/application/index.js.erb";
import PrtfAchievementTypeApiService from "../../Services/Api/PrtfAchievementTypeApi";
import PrtfAchievementKindApiService from "../../Services/Api/PrtfAchievementKindApi";

const {mapFields} = createHelpers({
  getterType: 'achievement/getPayloadAchievement',
  mutationType: 'achievement/updatePayloadAchievement',
});


export default {
  name: "TheFormFillingAchievements",

  components: {
    Trophy,
    TheAchievementFileInput,
    CriteriaAchievementTextField,
    TheAchievementKindSelect,
  },

  async mounted() {
    await this.getAchievementTypes();
    if (!_.isNil(this.prtf_achievement_type_id)) {
      await this.getAchievementKinds(this.prtf_achievement_type_id);
    }
  },

  data() {
    return {
      valid: false,
      achievementTypesList: [],
      achievementKindsList: [],
      nameRules: [
        v=> !!v || 'Введите название достижения',
        v=> /^.{3,128}$/.test(v) || 'Количество символов должно быть от 3 до 128.',
      ],
      descriptionRules: [
        v=> /^.{0,512}$/.test(v) || 'Количество символов должно быть до 512.',
      ],
      achievementTypeRules: [
        v=> !!v || 'Выберите тип достижения.',
      ],
      loading: false,
    }
  },

  watch: {
    dialog() {if(!this.dialog) this.$refs.formAchievement.resetValidation()},

    prtf_achievement_type_id() {
      if (_.isNil(this.prtf_achievement_type_id)) return this.achievementKindsList = [];
      this.getAchievementKinds(this.prtf_achievement_type_id);
    },
  },

  computed: {
    ...mapFields([
      'id',
      'name',
      'description',
      'prtf_achievement_type_id',
      'prtf_achievement_kind_id',
    ]),

    ...mapState({
      dialog: state => state.achievement.dialog,
      editMode: state => state.achievement.editModeForm,
      payload: state => state.achievement.payload,
      portfolioAchievements: store => store.achievement.portfolioAchievements,
    }),

    ...mapGetters({
      achievementComments: "achievement/achievementComments",
    }),

    achievementComments() {
      const id = this.payload?.id;
      if (_.isNil(id)) return []

      return _.find(this.portfolioAchievements, {'id': id})?.comments || []
    },

    typeBtnFormAchievement() {
      if (this.editMode) return () => this.updateBtn();
      else return () => this.createBtn();
    },

    titleBtnFormAchievement() {
      if (this.editMode) return "Обновить";
      else return "Создать";
    },

    currentAchievementKind() {
      const achievementKindId = this.prtf_achievement_kind_id;
      if (_.isNil(achievementKindId) || _.isEmpty(this.achievementKindsList)) return null

      return _.find(this.achievementKindsList, {"id": achievementKindId});
    },

  },

  methods: {
    ...mapActions({
      setDialogAction: 'achievement/setDialogAction',
      createAchievement: 'achievement/createAchievement',
      updateAchievement: 'achievement/updateAchievement',
    }),

    async createBtn() {
      if (this.$refs.formAchievement.validate()) {
        this.loading = true;
        try {
          await this.createAchievement();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
    },

    async updateBtn() {
      if(this.$refs.formAchievement.validate()) {
        this.loading = true;
        try {
          await this.updateAchievement();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
    },

    async getAchievementTypes() {
      const response = await PrtfAchievementTypeApiService.index();
      if(_.isNull(response)) return;

      this.achievementTypesList = response.data.achievement_types;
    },

    async getAchievementKinds(idType) {
      const response = await PrtfAchievementKindApiService.index(idType);
      if(_.isNull(response)) return;

      this.achievementKindsList = response.data.achievement_kinds;
    },



  },

}
</script>

<template>
  <v-form
    class="d-flex flex-column"
    v-model="valid"
    ref="formAchievement"
  >
    <v-card-title class="py-2 mb-0">
      <v-toolbar
        elevation="0"
        max-height="65px"
      >
        <v-toolbar-title style="color: #00796b">Новое Достижение</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-menu
          bottom
          :close-on-click="true"
          left
          :close-on-content-click="false"
          content-class="rounded-xl"
          max-height="250px"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              left
              color="warning"
              small
              v-show="achievementComments.length > 0"
            >
              fa-comment
            </v-icon>
          </template>
          <v-card
            width="400px"
            class="rounded-b-xl"
          >
            <v-card-text class="text-body-1 py-1">
              Проведите редактирование в соответствии с замечаниями
            </v-card-text>
            <v-divider/>
            <v-card-text class="py-0">
              <div v-for="(comment, index) in achievementComments" :key="comment.id">
                <v-list-item class="py-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="d-flex text-wrap">
                      <v-icon small left color="error"> fa-exclamation</v-icon>{{comment.comment}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-show="index !== achievementComments.length - 1"/>
                </div>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-menu
          bottom
          :close-on-click="true"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              left
              right
              small
            >
              fa fa-cog
            </v-icon>
          </template>
          <v-card max-width="600px">
            <v-card-text>Почта тех. поддержки: suleymanov.dk@amursu.ru</v-card-text>
          </v-card>
        </v-menu>

        <v-btn small icon @click="setDialogAction(false)" >
          <v-icon small>fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <v-container class="px-8 py-2">

        <v-text-field
          v-model="name"
          outlined
          :color="$store.state.achievement.side_color"
          :counter="128"
          label="Название*"
          required
          class="rounded-xl"
          :rules="nameRules"
          dense
        >
        </v-text-field>

        <v-select
          outlined
          :items="achievementTypesList"
          item-text="name"
          item-value="id"
          v-model="prtf_achievement_type_id"
          :color="$store.state.achievement.side_color"
          label="Тип достижения*"
          clearable
          no-data-text="Типы достижений отсутсвуют"
          class="rounded-xl"
          :rules="achievementTypeRules"
          dense
        >
        </v-select>

        <the-achievement-kind-select :achievement-kinds-list="achievementKindsList"/>

        <criteria-achievement-text-field
          v-if="prtf_achievement_kind_id !== null"
          :achievement-kind="currentAchievementKind"
        />

        <v-textarea
          v-model="description"
          dense
          row="5"
          row-height="20"
          outlined
          :color="$store.state.achievement.side_color"
          label="Описание"
          class="rounded-xl"
          :rules="descriptionRules"
          :counter="512"
        >
        </v-textarea>

        <the-achievement-file-input
          :achievement-kind="currentAchievementKind"
        />
      </v-container>
    </v-card-text>

    <div class="card-img">
      <trophy
        width="300px"
        height="300px"
      />
    </div>

    <v-card-actions class="d-flex flex-row justify-center align-center pb-14">
      <v-btn
        @click="typeBtnFormAchievement"
        class="white--text px-4 rounded-lg"
        :color="$store.state.achievement.side_color"
        :loading="loading"
      >
        {{titleBtnFormAchievement}}
      </v-btn>
      <v-btn
        outlined
        class="rounded-lg px-2"
        :color="$store.state.achievement.cancel_color"
        @click="setDialogAction(false)"
        :loading="loading"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<style scoped>
.active--chip {
  color: white;
  background: #00796b;
}

.card-img {
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  object-fit: contain;
  opacity: 0.05;
  overflow: hidden;
  transform: translate(75px, 75px);
}

</style>